module.exports = __webpack_public_path__ + "img/icon-bf.ca4ecdcb.png";